import React from "react"

import UserIcon from "../../../../../gd-components/icons/user/user"
import ControlButtonStandard from "../../../../../gd-components/buttons/control-button/control-button-standard";

type Option = {
    value: any
    label: string
}

type Props = {
    option      : Option
    onRemove?   : {(option:Option):void} | null
}

const debug = false
// const debug = 'FieldAssignees_SelectedOption'

export default function FieldAssignees_SelectedOption(props:Props) {
    return (
        <div className="option pill">
            <UserIcon className = "fl-no-shrink m-r-8"
                      size      = "22"
                      userId    = {props.option.value}/>
            <div className="ui5-txt-default txt-truncate max-w-100-percent">{props.option.label}</div>
            {!!props.onRemove &&
                <div className="flex-1 flex-row-right-center m-l-10">
                    <ControlButtonStandard iconClass    = "fs-15 i5-trash-alt"
                                           onClick      = {() => {props.onRemove!(props.option)}}/>
                </div>}
        </div>
    )
}